module.exports = __webpack_public_path__ + "media/red-winged-blackbird-3.dc94bdc3.mp3";